module.exports = __webpack_public_path__ + "static/media/JOS.d3f26023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/JOS.png
// module id = 374
// module chunks = 25